import { InjectionToken } from '@angular/core';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';

export const FP_LOGGER_NOISE_TAB_CONNECT_SERVICES = new InjectionToken<IFpLoggerNoiseTabConnectService[]>(
  'FP_LOGGER_NOISE_TAB_CONNECT_SERVICES',
  {
    factory: () => {
      return [];
    },
  }
);
